// // NotFoundPage.js
// import React, { useState, useEffect } from 'react';
// import Header from '../components/Header';
// import Loading from '../components/Loader';
// import ErrorPage from './ErrorPage';
// import GameLaunchWindow from '../components/GameLaunchWindow';
// import queryString from 'query-string';

// const GameLaunch = (props) => {
//   // const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const [url, setURL] = useState(null);
  
//   const launchData = queryString.parse(window.location.search);
  
//   useEffect(() => {
//     if (launchData) {
//       try {
//         let launchObj = JSON.parse(launchData.params);
//         setURL(launchObj.url); 
//       } catch (err) {
//         setError("Failed to parse launch data.");
//       }
//     }
//   }, [launchData]);

  
//     if (loading) {
//       return (url && 
//         <div>
//           <Header title = {"Game Launch"} />
//           <Loading />
//         </div>
//       );
//     }
  
//     if (error) {
//       return <ErrorPage errorMessage={error} />
//     }

//     return (
//       <div>
//         <GameLaunchWindow url={url} />
//       </div>
//     );
// };

// export default GameLaunch;

// Jan20, 2026
// =========================================================
// import React, { useState, useEffect } from 'react';
// import Header from '../components/Header';
// import Loading from '../components/Loader';
// import ErrorPage from './ErrorPage';
// import GameLaunchWindow from '../components/GameLaunchWindow';
// import queryString from 'query-string';

// const GameLaunch = () => {
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [url, setURL] = useState(null);

//   const launchData = queryString.parse(window.location.search);

//   useEffect(() => {
//     if (launchData && launchData.url) {
//       try {
//         // URL may be URI encoded, so decode it
//         // const decodedUrl = decodeURIComponent(launchData.url);
//         const decodedUrl = launchData.url;
//         setURL(decodedUrl);
//       } catch (err) {
//         setError("Failed to decode launch URL.");
//       }
//     } else {
//       setError("Missing launch URL.");
//     }
//   }, [launchData]);

//   if (loading) {
//     return url && (
//       <div>
//         <Header title="Game Launch" />
//         <Loading />
//       </div>
//     );
//   }

//   if (error) {
//     return <ErrorPage errorMessage={error} />;
//   }

//   return (
//     <div>
//       <GameLaunchWindow url={url} />
//     </div>
//   );
// };

// export default GameLaunch;


import { useEffect } from 'react';
import queryString from 'query-string';
import ErrorPage from './ErrorPage';

const GameLaunch = () => {
  const launchData = queryString.parse(window.location.search);

  useEffect(() => {
    if (launchData?.url) {
      try {
        const decodedUrl = launchData.url; // decodeURIComponent if needed
        window.location.replace(decodedUrl);
      } catch (err) {
        console.error('Invalid launch URL');
      }
    }
  }, [launchData]);

  if (!launchData?.url) {
    return <ErrorPage errorMessage="Missing launch URL." />;
  }

  // Nothing to render because page will redirect
  return null;
};

export default GameLaunch;
